import React from 'react'
import { t } from 'src/translations'

import Image from 'src/shared/components/common/Image'

const CommissionDisclaimer = () => (
  <div className='commission-disclaimer'>
    <div className='storefront-icon'>
      <Image src='/icons/storefront.svg' alt='' />
    </div>
    <p>{t('commission-disclaimer.orders-commission-free')}</p>
  </div>
)

export default CommissionDisclaimer
